export default __webpack_public_path__ + "static/media/renting.2abb499a.svg";